import * as React from "react";

const useStickyOffsets = (columns) => {
  return React.useMemo(() => {
    const stickyOffsets = [];
    let leftOffset = 0;
    let rightOffset = 0;

    columns.forEach((column, index) => {
      if (column.columnDef?.sticky) {
        stickyOffsets.push({
          offset: leftOffset,
          index,
          position: "left",
        });

        leftOffset += column.getSize();
      } else if (column.columnDef?.rightSticky) {
        stickyOffsets.push({
          offset: rightOffset,
          index,
          position: "right",
        });

        rightOffset += column.getSize();
      }
    });
    return stickyOffsets;
  }, [columns]);
};

export default useStickyOffsets;
